(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["martillo-cooler-purchase"] && !Shopify.designMode) return;
  try {
    
(() => {
  document.querySelectorAll('[data-cooler-purchase]').forEach((root) => {
    const gallery = root.querySelector('[data-product-gallery]');
    const viewport = gallery?.querySelector('[data-gallery-viewport]');
    const mainImage = gallery?.querySelector('.gallery-main img');
    const count = gallery?.querySelector('[data-gallery-count]');
    const thumbnails = Array.from(gallery?.querySelectorAll('[data-gallery-thumb]') || []);
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let activeMedia = 0;
    let pointerStart = null;
    const showMedia = (index, focusThumbnail = false) => {
      if (!mainImage || !thumbnails.length) return;
      activeMedia = (Number(index) + thumbnails.length) % thumbnails.length;
      const thumbnail = thumbnails[activeMedia];
      const swap = () => {
        mainImage.src = thumbnail.dataset.src;
        mainImage.alt = thumbnail.dataset.alt;
        mainImage.dataset.mediaStyle = thumbnail.dataset.style || 'primary';
        mainImage.classList.remove('is-changing');
      };
      if (reducedMotion.matches) swap();
      else {
        mainImage.classList.add('is-changing');
        window.setTimeout(swap, 90);
      }
      thumbnails.forEach((item, itemIndex) => {
        const active = itemIndex === activeMedia;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-selected', active ? 'true' : 'false');
        item.tabIndex = active ? 0 : -1;
      });
      if (count) count.textContent = `${activeMedia + 1} / ${thumbnails.length}`;
      if (focusThumbnail) thumbnail.focus();
    };
    thumbnails.forEach((thumbnail, index) => {
      thumbnail.addEventListener('click', () => showMedia(index));
      thumbnail.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Home') showMedia(0, true);
        else if (event.key === 'End') showMedia(thumbnails.length - 1, true);
        else showMedia(index + (event.key === 'ArrowRight' ? 1 : -1), true);
      });
    });
    viewport?.addEventListener('pointerdown', (event) => { pointerStart = event.clientX; });
    viewport?.addEventListener('pointerup', (event) => {
      if (pointerStart === null) return;
      const distance = event.clientX - pointerStart;
      pointerStart = null;
      if (Math.abs(distance) > 46) showMedia(activeMedia + (distance < 0 ? 1 : -1));
    });
    const quantityInput = root.querySelector('[data-quantity-input]');
    const clamp = (value) => Math.min(99, Math.max(1, Number.parseInt(value, 10) || 1));
    root.querySelector('[data-quantity-minus]')?.addEventListener('click', () => { quantityInput.value = String(clamp(Number(quantityInput.value) - 1)); });
    root.querySelector('[data-quantity-plus]')?.addEventListener('click', () => { quantityInput.value = String(clamp(Number(quantityInput.value) + 1)); });
    quantityInput?.addEventListener('change', () => { quantityInput.value = String(clamp(quantityInput.value)); });
    showMedia(0);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["martillo-hero-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('martillo-hero-carousel')) {
    class MartilloHeroCarousel extends HTMLElement {
      connectedCallback() {
        this.listenerController?.abort();
        this.listenerController = new AbortController();
        const listenerOptions = { signal: this.listenerController.signal };
        this.slides = Array.from(this.querySelectorAll('[data-carousel-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-carousel-dot]'));
        this.viewport = this.querySelector('[data-carousel-viewport]');
        this.pauseButton = this.querySelector('[data-carousel-pause]');
        this.status = this.querySelector('[data-carousel-status]');
        this.currentIndex = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
        this.interval = Number(this.dataset.interval) || 7000;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.userPaused = false;
        this.hovered = false;
        this.focused = false;
        this.dragStart = null;
        this.dragged = false;

        this.previousButton = this.querySelector('[data-carousel-previous]');
        this.nextButton = this.querySelector('[data-carousel-next]');

        this.previousButton?.addEventListener('click', () => this.show(this.currentIndex - 1, true), listenerOptions);
        this.nextButton?.addEventListener('click', () => this.show(this.currentIndex + 1, true), listenerOptions);
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.show(Number(dot.dataset.carouselDot), true), listenerOptions));
        this.pauseButton?.addEventListener('click', () => this.togglePause(), listenerOptions);

        this.addEventListener('mouseenter', () => {
          this.hovered = true;
          this.stop();
        }, listenerOptions);
        this.addEventListener('mouseleave', () => {
          this.hovered = false;
          this.start();
        }, listenerOptions);
        this.addEventListener('focusin', () => {
          this.focused = true;
          this.stop();
        }, listenerOptions);
        this.addEventListener('focusout', () => {
          requestAnimationFrame(() => {
            this.focused = this.contains(document.activeElement);
            this.start();
          });
        }, listenerOptions);

        this.viewport?.addEventListener('pointerdown', (event) => this.onPointerDown(event), listenerOptions);
        this.viewport?.addEventListener('pointerup', (event) => this.onPointerUp(event), listenerOptions);
        this.viewport?.addEventListener('pointercancel', () => this.onPointerCancel(), listenerOptions);
        document.addEventListener('visibilitychange', () => this.start(), listenerOptions);
        document.addEventListener('shopify:block:select', (event) => this.onBlockSelect(event), listenerOptions);
        this.reducedMotion.addEventListener?.('change', () => this.start(), listenerOptions);

        this.show(this.currentIndex, false);
        this.start();
      }

      disconnectedCallback() {
        this.stop();
        this.listenerController?.abort();
      }

      show(index, announce) {
        if (this.slides.length < 1) return;
        this.currentIndex = (index + this.slides.length) % this.slides.length;

        this.slides.forEach((slide, slideIndex) => {
          const active = slideIndex === this.currentIndex;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
          slide.inert = !active;
        });

        this.dots.forEach((dot, dotIndex) => {
          const active = dotIndex === this.currentIndex;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });

        if (announce && this.status) {
          this.status.textContent = `Slide ${this.currentIndex + 1} of ${this.slides.length}`;
        }

        this.start();
      }

      start() {
        this.stop();
        if (
          this.slides.length < 2 ||
          this.userPaused ||
          this.hovered ||
          this.focused ||
          this.reducedMotion.matches ||
          document.hidden ||
          Shopify.designMode
        ) return;

        this.timer = window.setInterval(() => this.show(this.currentIndex + 1, false), this.interval);
      }

      stop() {
        window.clearInterval(this.timer);
      }

      togglePause() {
        this.userPaused = !this.userPaused;
        const label = this.pauseButton?.querySelector('[data-pause-label]');
        if (label) label.textContent = this.userPaused ? 'Play' : 'Pause';
        this.pauseButton?.setAttribute('aria-label', this.userPaused ? 'Play carousel' : 'Pause carousel');
        this.start();
      }

      onPointerDown(event) {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        this.dragStart = event.clientX;
        this.dragged = false;
        this.stop();
        this.viewport?.setPointerCapture?.(event.pointerId);
      }

      onPointerUp(event) {
        if (this.dragStart === null) return;
        const distance = event.clientX - this.dragStart;
        this.dragStart = null;
        this.dragged = Math.abs(distance) > 44;

        if (this.dragged) {
          this.show(distance > 0 ? this.currentIndex - 1 : this.currentIndex + 1, true);
          if (event.pointerType !== 'mouse') {
            this.userPaused = true;
            const label = this.pauseButton?.querySelector('[data-pause-label]');
            if (label) label.textContent = 'Play';
            this.pauseButton?.setAttribute('aria-label', 'Play carousel');
          }
        }

        this.start();
      }

      onPointerCancel() {
        this.dragStart = null;
        this.start();
      }

      onBlockSelect(event) {
        const slide = event.target?.closest?.('[data-carousel-slide]');
        if (!slide || !this.contains(slide)) return;
        this.userPaused = true;
        this.show(Number(slide.dataset.slideIndex), false);
      }
    }

    customElements.define('martillo-hero-carousel', MartilloHeroCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["martillo-product-nav"]) return;
  try {
    
  class MartilloProductNav extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      const initialize = () => {
        const main = document.getElementById('MainContent');
        if (!main) return;
        let purchase = main.querySelector('#purchase');
        if (!purchase) {
          purchase = main.querySelector('.product-information') || main;
          if (!purchase.id) purchase.id = 'purchase';
        }
        this.querySelectorAll('a[href="#purchase"]').forEach(link => { link.hash = purchase.id; });
        const details = main.querySelector('.mt-source-document, .mt-accessory-pdp__screenshot-detail, .mt-accessory-pdp__detail');
        const detailsLink = this.querySelector('[data-product-nav-details]');
        if (details && detailsLink) {
          if (!details.id) details.id = 'product-details';
          details.classList.add('mt-product-nav-target');
          detailsLink.hash = details.id;
          detailsLink.hidden = false;
        }
        const wrapper = this.closest('.page-wrapper');
        this.observer?.disconnect();
        this.observer = new ResizeObserver(() => wrapper?.style.setProperty('--mt-product-nav-height', `${this.offsetHeight}px`));
        this.observer.observe(this);
        this.querySelectorAll('a').forEach(link => {
          if (!link.hash || link.origin !== location.origin || link.pathname !== location.pathname) return;
          link.addEventListener('click', event => {
            const target = document.getElementById(link.hash.slice(1));
            if (!target) return;
            event.preventDefault();
            const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            if (reducedMotion) {
              const scroller = window.innerWidth >= 990 ? wrapper : document.documentElement;
              const previous = scroller.style.scrollBehavior;
              scroller.style.scrollBehavior = 'auto';
              target.scrollIntoView({ block: 'start', behavior: 'instant' });
              scroller.style.scrollBehavior = previous;
            } else {
              target.scrollIntoView({ block: 'start', behavior: 'smooth' });
            }
            const focusTarget = link.hasAttribute('data-product-nav-buy')
              ? main.querySelector('h1') || target
              : target;
            if (!focusTarget.matches('a, button, input, select, textarea, [tabindex]')) focusTarget.setAttribute('tabindex', '-1');
            focusTarget.focus({ preventScroll: true });
            history.replaceState(null, '', link.hash);
          }, { signal });
        });
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true, signal });
      else initialize();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.closest('.page-wrapper')?.style.removeProperty('--mt-product-nav-height');
    }
  }
  if (!customElements.get('martillo-product-nav')) customElements.define('martillo-product-nav', MartilloProductNav);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["martillo-source-document"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-mt-source-document]').forEach((root) => {
    const dialog = root.querySelector('[data-mt-source-dialog]');
    const image = root.querySelector('[data-mt-source-dialog-image]');
    if (!dialog || !image) return;
    root.querySelectorAll('[data-mt-source-enlarge]').forEach((button) => {
      button.addEventListener('click', () => {
        image.src = button.dataset.mtSourceEnlarge;
        image.alt = button.querySelector('img')?.alt || '';
        image.width = button.querySelector('img').width;
        image.height = button.querySelector('img').height;
        dialog.showModal();
      });
    });
    root.querySelector('[data-mt-source-close]')?.addEventListener('click', () => dialog.close());
    dialog?.addEventListener('close', () => { image.removeAttribute('src'); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["martillo-support-resources"] && !Shopify.designMode) return;
  try {
    
  function initMartilloSupport() {
    const resources = document.querySelector('[data-support-resources]');
    if (!resources || resources.dataset.initialized === 'true') return;
    resources.dataset.initialized = 'true';
    const cards = [...document.querySelectorAll('[data-support-product-card]')];
    const tabs = [...resources.querySelectorAll('[data-support-product-tab]')];
    const topics = [...resources.querySelectorAll('[data-support-topic]')];
    const topicLinks = [...resources.querySelectorAll('[data-support-topic-link]')];
    const resourcesTitle = resources.querySelector('h2');
    let activeProduct = cards.find((card) => card.classList.contains('is-active'))?.dataset.productKey || 'm2';

    const productRank = (element) => element.dataset.productKey === 'm2' ? 0 : 1;
    const sortByMerchantOrder = (left, right) => {
      const productDifference = productRank(left) - productRank(right);
      if (productDifference !== 0) return productDifference;
      return Number(left.dataset.sortOrder || 0) - Number(right.dataset.sortOrder || 0);
    };
    const topicNav = resources.querySelector('.mt-support-topic-nav');
    const topicList = resources.querySelector('.mt-support-topic-list');
    topicLinks.sort(sortByMerchantOrder).forEach((link) => topicNav?.append(link));
    topics.sort(sortByMerchantOrder).forEach((topic) => topicList?.append(topic));

    const selectProduct = (productKey, scroll) => {
      activeProduct = productKey;
      cards.forEach((card) => {
        const active = card.dataset.productKey === productKey;
        card.classList.toggle('is-active', active);
        card.setAttribute('aria-pressed', String(active));
      });
      tabs.forEach((tab) => { const active = tab.dataset.supportProductTab === productKey; tab.setAttribute('aria-selected', String(active)); tab.tabIndex = active ? 0 : -1; });
      topics.forEach((topic) => {
        const visible = topic.dataset.productKey === productKey;
        topic.hidden = !visible;
        topic.open = visible;
        topic.querySelector('summary')?.setAttribute('aria-expanded', String(visible));
      });
      topicLinks.forEach((link) => {
        link.hidden = link.dataset.productKey !== productKey;
        link.classList.toggle('is-active', link.dataset.productKey === productKey && link === topicLinks.find(item => item.dataset.productKey === productKey));
      });
      resources.querySelectorAll('[data-support-model-tab]').forEach((tab) => tab.setAttribute('aria-selected', 'false'));
      resources.querySelectorAll('[data-support-model-panel]').forEach((panel) => { panel.hidden = true; });
      if (scroll) {
        resources.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
        setTimeout(() => resourcesTitle?.focus({ preventScroll: true }), 350);
      }
    };

    cards.forEach((card) => card.addEventListener('click', () => selectProduct(card.dataset.productKey, true)));
    tabs.forEach((tab) => tab.addEventListener('click', () => selectProduct(tab.dataset.supportProductTab, false)));
    topicLinks.forEach((link) => link.addEventListener('click', () => {
      const topic = resources.querySelector(`[data-support-topic="${CSS.escape(link.dataset.supportTopicLink)}"]`);
      if (!topic || topic.hidden) return;
      topic.open = true;
      topicLinks.forEach(item => item.classList.toggle('is-active', item === link));
      topic.querySelector('summary')?.focus({preventScroll:true});
      topic.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    }));
    topics.forEach((topic) => topic.addEventListener('toggle', () => {
      const link = topicLinks.find((item) => item.dataset.supportTopicLink === topic.dataset.supportTopic);
      if (!topic.open) link?.classList.remove('is-active');
      topic.querySelector('summary')?.setAttribute('aria-expanded', String(topic.open));
    }));

    resources.querySelectorAll('[data-support-quick-link]').forEach(link => link.addEventListener('click', event => {
      event.preventDefault();
      const topic = resources.querySelector('[data-support-topic="m2-installation"]');
      if (!topic) return;
      topic.open = true;
      topic.scrollIntoView({behavior:'auto', block:'start'});
      topic.querySelector('summary').focus({preventScroll:true});
    }));
    tabs.forEach((tab, index) => tab.addEventListener('keydown', event => {
      if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
      event.preventDefault();
      const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length-1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
      selectProduct(tabs[next].dataset.supportProductTab, false);
      tabs[next].focus();
    }));

    selectProduct(activeProduct, false);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initMartilloSupport);
  else initMartilloSupport();
  document.addEventListener('shopify:section:load', initMartilloSupport);

  } catch(e) { console.error(e); }
})();
})();
